<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.applyTrackings'), $t('text.list')]">
        <el-button
          v-if="Permit.isChargeEdition()"
          type="success"
          size="mini"
          @click="$router.push('/normal/lms/apply-trackings/loop')"
        >
          {{ $t("action.loopWeight") }}
        </el-button>
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.serialNoInnerSerialNo')"
          />
        </el-form-item>

        <customer-search
          v-model="searchForm"
          fieldId="customerId"
          fieldName="customerName"
        />

        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.categoryName"
            :placeholder="$t('menu.categories')"
            filterable
            clearable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.specJson"
            :placeholder="$t('product.specJson')"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.customerType"
            :placeholder="$t('bargain.customerType')"
            filterable
            clearable
          >
            <el-option
              v-for="customerType in customerTypes"
              :key="customerType"
              :label="$t('customerTypes.' + customerType)"
              :value="customerType"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="handOverAt"
            :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
          />
        </el-form-item>

        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="latestShipDate"
            :start-placeholder="
              $t('rules.startAt', [$t('bargain.latestShipDate')])
            "
            :end-placeholder="$t('rules.endAt', [$t('bargain.latestShipDate')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="latestDeliveryDate"
            :start-placeholder="
              $t('rules.startAt', [$t('bargain.latestDeliveryDate')])
            "
            :end-placeholder="
              $t('rules.endAt', [$t('bargain.latestDeliveryDate')])
            "
          />
        </el-form-item>

        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model="searchForm.ownerId"
            filterable
            clearable
            :placeholder="$t('text.owner')"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model="searchForm.shopId"
            :placeholder="$t('menu.shops')"
            filterable
            clearable
          >
            <el-option
              v-for="shop in shops"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.remark"
            :placeholder="$t('order.remark')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.deliveryRemark"
            :placeholder="$t('bargain.deliveryRemark')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>

    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              type="warning"
              size="mini"
              @click="batchUploadTracking"
              >{{ $t("action.batchUploadTracking") }}</el-button
            >
            <div
              v-if="Permit.extendModels().includes('lmsC')"
              class="float-left"
            >
              <el-button
                v-for="courierTenant of courierTenants"
                :key="courierTenant.id"
                type="default"
                size="mini"
                class="mgb5"
              >
                <el-popover placement="right" width="640" trigger="click">
                  <div>
                    <el-row>
                      <el-col
                        v-for="deliverMethod of courierTenant.courier
                          .deliverMethods"
                        :key="deliverMethod.id"
                        :span="8"
                        class="agentBg"
                      >
                        <span
                          @click="
                            batchGetTracking(courierTenant, deliverMethod)
                          "
                        >
                          {{ deliverMethod.name }}
                        </span>
                      </el-col>
                    </el-row>
                    <div
                      v-if="courierTenant.courier.login == 'lianbang'"
                      class="center"
                    >
                      <img src="@/assets/fedex.jpg" style="width: 80px" />
                      <div style="font-size: 8pt" class="strong">
                        The FedEx service marks are owned by Federal Express
                        Corporation and are used by permission.
                      </div>
                    </div>
                  </div>
                  <span slot="reference">
                    {{ courierTenant.courier.name }}
                    <i class="el-icon-caret-bottom el-icon--right"></i>
                  </span>
                </el-popover>
              </el-button>
            </div>

            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="selectRecord"
        @checkbox-all="selectAllRecords"
        :checkbox-config="{ reserve: true, checkMethod: checkColumnMethod }"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :custom-config="{ storage: true }"
        :span-method="mergeMethod"
        :loading="loading"
        id="bargainsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="calculateBgColor"
        size="mini"
        resizable
        round
        auto-resize
        :scroll-y="{ enabled: false }"
        highlight-hover-row
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column field="flags" :title="$t('text.flag')" width="50">
          <template v-slot="{ row, rowIndex }">
            <span v-if="!row.isBargain && !row.isLoadDF">
              <span v-if="row.flags != null && row.flags != ''">
                <flag
                  :name="flag"
                  :size="14"
                  v-for="flag in JSON.parse(row.flags)"
                  :key="flag"
                ></flag>
              </span>
            </span>
            <div v-if="row.isBargain">
              <span class="float-left">
                <span
                  :class="cancelBardain(row) ? 'deleted mgr5' : 'blue mgr5'"
                  @click="showBargain(row)"
                >
                  {{ row.serialNo }}
                </span>
                <span class="font10 mgr5"
                  >{{ $t("bargain.productQty") }}:{{ row.productQty }}</span
                >
                <span
                  v-if="Permit.canActions('globalSalePrice')"
                  class="font10"
                >
                  <span class="mgr5">
                    {{ $t("bargain.amount") }}:
                    <currency :code="row.currency"></currency>
                    {{ row.amount }}
                  </span>
                  <span v-if="row.settleType == 'later'">{{
                    $t("settleTypes.later")
                  }}</span>
                  <span v-if="row.settleType == 'now'">
                    <span class="mgr5">
                      {{ $t("bargain.receive") }}:
                      <currency :code="row.currency"></currency>
                      {{ row.payAmount }}
                    </span>
                    <span v-if="row.ignoreAmount > 0" class="mgr5">
                      {{ $t("bargain.ignore") }}:
                      <currency :code="row.currency"></currency>
                      {{ row.ignoreAmount }}
                    </span>
                    <span v-if="row.differAmount > 0" class="red mgr5">
                      {{ $t("bargain.differ") }}:
                      <currency :code="row.currency"></currency>
                      {{ row.differAmount }}
                    </span>
                    <span v-if="row.differAmount == 0" class="green mgr5">{{
                      $t("bargain.settled")
                    }}</span>
                    <span v-if="row.differAmount < 0" class="orange">
                      {{ $t("bargain.leave") }}:
                      <currency :code="row.currency"></currency>
                      {{ row.differAmount * -1 }}
                    </span>
                  </span>
                </span>
              </span>
              <div v-if="row.financeAudit != null" class="font12 float-left">
                <el-popover placement="right" width="300" trigger="click">
                  <div>
                    <div class="lineH24">
                      {{ $t("verify.commentName") }}:
                      {{ row.financeAudit.commentName }}
                    </div>
                    <div class="lineH24">
                      {{ $t("verify.commentAt") }}:
                      {{ row.financeAudit.commentAt }}
                    </div>
                    <div
                      v-if="row.financeAudit.dealType == 'reject'"
                      class="lineH24"
                    >
                      {{ $t("verify.comment") }}:
                      {{ row.financeAudit.comment }}
                    </div>
                  </div>
                  <span
                    slot="reference"
                    class="popover-reference"
                    :class="
                      row.financeAudit.dealType == 'agree'
                        ? 'green-shallow'
                        : 'red'
                    "
                    >{{ $t("action.verify") }}({{
                      $t("verifyTypesSimple." + row.financeAudit.dealType)
                    }})</span
                  >
                </el-popover>
              </div>
              <span v-if="row.groupJson != null && row.groupJson != ''">
                <div
                  v-for="item in JSON.parse(row.groupJson)"
                  :key="item"
                  class="group"
                  :type="item"
                  size="small"
                >
                  {{ item }}
                  <i
                    class="el-tag__close el-icon-close"
                    @click="deleteGroup(row, rowIndex, item)"
                  ></i>
                </div>
              </span>
              <template>
                <el-popover
                  placement="right"
                  width="800"
                  trigger="click"
                  @show="getRequestResponses(row)"
                >
                  <vxe-table
                    :data="requestResponses"
                    id="requestResponsesTable"
                    row-id="id"
                    ref="deliverInfosTable"
                    class="recordsTable"
                    size="mini"
                    resizable
                    round
                    auto-resize
                    highlight-hover-row
                    :scroll-y="{ enabled: false }"
                  >
                    <vxe-table-column
                      field="request"
                      :title="$t('requestResponse.request')"
                      min-width="160"
                    >
                      <template v-slot="{ row }">
                        <raw-html-limit-number
                          :content="row.request"
                          :number="120"
                          type="richText"
                        />
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                      field="response"
                      :title="$t('requestResponse.response')"
                      min-width="160"
                    >
                      <template v-slot="{ row }">
                        <raw-html-limit-number
                          :content="row.response"
                          :number="120"
                          type="richText"
                        />
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                      field="requestAt"
                      :title="$t('requestResponse.requestAt')"
                      width="110"
                    />
                  </vxe-table>
                  <span slot="reference" class="popover-reference">
                    <span v-if="row.isFail == true" class="red">
                      {{ $t("bargain.getTrackingFail") }}
                    </span>
                    <span v-else>
                      <span v-if="row.tracking != null" class="blue">
                        {{ $t("delivery.tracking2") }}:{{ row.tracking }}
                      </span>
                    </span>
                    <small v-if="row.bargainCourierInfo">
                      {{ row.bargainCourierInfo.courierName }}/{{
                        row.bargainCourierInfo.deliverMethodName
                      }}({{ $t("category.hsCode") }}:
                      {{ row.bargainCourierInfo.hsCode }}
                      {{ $t("category.goodsName") }}:
                      {{ row.bargainCourierInfo.goodsName }}
                      {{ $t("category.goodsNameEn") }}:
                      {{ row.bargainCourierInfo.goodsNameEn }}
                      {{ $t("category.weight") }}:
                      {{ row.bargainCourierInfo.selfWeight }}
                      {{ $t("delivery.insured") }}:
                      {{ row.bargainCourierInfo.insured }})
                    </small>
                  </span>
                </el-popover>
              </template>
              <span class="float-right font10">
                <el-popover placement="right" width="300" trigger="click">
                  <div>
                    <div class="lineH24">
                      {{ $t("menu.customers") }}：{{ row.customerName }}
                    </div>
                    <div class="lineH24" v-if="row.customerType != null">
                      {{ $t("bargain.customerType") }}：
                      {{ $t("customerTypes." + row.customerType) }}
                    </div>
                    <div class="lineH24">
                      {{ $t("bargain.customerPhone") }}：
                      {{ row.customerPhone }}
                    </div>
                    <div class="lineH24">
                      {{ $t("tenant.country") }}：
                      <span v-if="row.customerCountry != null">{{
                        $t("countries." + row.customerCountry)
                      }}</span>
                    </div>
                    <div class="lineH24">
                      {{ $t("tenant.province") }}：{{ row.customerProvince }}
                    </div>
                    <div class="lineH24">
                      {{ $t("tenant.city") }}：{{ row.customerCity }}
                    </div>
                    <div class="lineH24">
                      {{ $t("tenant.address") }}：{{ row.customerAddress }}
                    </div>
                    <div class="lineH24">
                      {{ $t("customer.zipcode") }}：{{ row.customerZipcode }}
                    </div>
                    <div class="lineH24">
                      {{ $t("bargain.deliveryRemark") }}：{{
                        row.deliveryRemark
                      }}
                    </div>
                  </div>
                  <span slot="reference" class="popover-reference">
                    {{ $t("menu.customers") }}:{{ row.customerName }}
                    <span
                      v-if="row.customer != null && row.customer.type != null"
                    >
                      ({{ $t("customerTypes." + row.customer.type) }})
                    </span>
                    (<span v-if="row.customerCountry != null">{{
                      $t("countries." + row.customerCountry)
                    }}</span
                    >{{ row.customerProvince }})
                  </span>
                </el-popover>
                <raw-html
                  :content="row.deliveryRemark"
                  style="color: #ff9b6a"
                  class="float-right"
                />

                {{ $t("text.owner") }}:{{ row.ownerName }} {{ row.shopName }}
                <el-button
                  v-if="row.tracking != null && canCancelTracking(row)"
                  type="text"
                  size="mini"
                  :loading="cancelTrackingDoing"
                  @click="cancelTracking(row)"
                  >{{ $t("action.cancelTracking") }}</el-button
                >
                <span class="font8" v-if="row.latestShipDate != null"
                  >{{ $t("bargain.latestShipDate") }}:{{ row.latestShipDate
                  }}<span class="orange"
                    >{{ Util.dateDiff(row.latestShipDate, new Date()) }}天</span
                  ></span
                >
                <span class="font8" v-if="row.latestDeliveryDate != null"
                  >{{ $t("bargain.latestDeliveryDate") }}:{{
                    row.latestDeliveryDate
                  }}<span class="orange"
                    >{{
                      Util.dateDiff(row.latestDeliveryDate, new Date())
                    }}天</span
                  ></span
                >
              </span>
            </div>
            <div v-if="row.isLoadDF" class="center">
              <i class="el-icon-loading" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="120"
        >
          <template v-slot="{ row, rowIndex }">
            <small v-if="row.hurry" class="red"
              >({{ $t("order.hurrySimple") }})</small
            >
            <span @click="showOrder(row, rowIndex)" class="font10">
              <s v-if="row.workflowState == 'canceled'" class="grey">{{
                row.serialNo
              }}</s>
              <span v-else class="blue">{{ row.serialNo }}</span>
            </span>
            <div class="font10">{{ row.innerSerialNo }}</div>
            <div>
              <state-label
                :state="row.workflowState"
                :permit="Permit.canActions('orderDealView')"
              >
                <span v-if="Permit.canActions('orderDealView')">{{
                  $t("orderStates." + row.workflowState)
                }}</span>
                <span v-else>{{
                  $t("orderStatesNoPermit." + row.workflowState)
                }}</span>
              </state-label>
              <span v-if="row.isScore == true" class="font10 green">{{
                $t("order.isScore")
              }}</span>
            </div>
            <div
              v-if="row.labelsJson != null && row.labelsJson != ''"
              class="font10"
            >
              {{ JSON.parse(row.labelsJson).join(",") }}
            </div>
            <div
              v-if="row.settlementId != null && row.settlementId != 0"
              class="green font10"
            >
              {{ $t("purchase.settlement") }}:{{ row.settleAt }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="120"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.handOverAt }}
            <div
              v-if="!Permit.isFreeEdition() && row.confirmAt != null"
              class="font10 green"
            >
              {{ $t("order.confirm") }}:{{ row.confirmAt }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >

            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">
              <span
                :class="
                  row.color != null &&
                  row.color != '' &&
                  !Util.regexChinese(row.color)
                    ? 'red'
                    : ''
                "
                >{{ row.color }}</span
              >
              {{ row.size }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="150"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="12"
              type="richText"
            />
            <div
              class="orange font10"
              v-if="row.orderRemark != null && row.orderRemark != ''"
            >
              {{ $t("order.orderRemark") }}:
              <raw-html-limit-number :content="row.orderRemark" :number="12" />
            </div>
            <div
              class="orange font10"
              v-if="row.settlementRemark != null && row.settlementRemark != ''"
            >
              {{ $t("order.settlementRemark") }}:
              <raw-html-limit-number
                :content="row.settlementRemark"
                :number="6"
              />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specJson"
          :title="$t('product.specJson')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <attribute :content="row.specJson" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="Permit.canActions('globalSalePrice')"
          field="price"
          :title="$t('order.price')"
          min-width="100"
        >
          <template v-slot="{ row, rowIndex }">
            <span v-if="row.isScore == true"
              >{{ row.score
              }}<span class="font10">{{ $t("product.score") }}</span></span
            >
            <span v-else>
              <currency :code="row.currency"></currency>
              {{ row.price }}
              <small v-if="row.discountRate != null && row.discountRate != 0"
                >({{ row.discountRate }}%)</small
              >
              <div
                v-if="row.extraCharge != null && row.extraCharge != 0"
                class="font10"
              >
                {{ $t("order.extraChargeSimple") }}:
                <currency :code="row.currency"></currency>
                {{ row.extraCharge }}
              </div>
              <div class="font8">
                {{ $t("order.salePriceSimple") }}:
                <currency :code="row.currency"></currency>{{ row.productPrice }}
              </div>
              <div
                v-if="row.follow == false && row.settlementId != 0"
                class="font10"
              >
                {{ $t("product.quotation") }}:
                <currency :code="row.currency"></currency>{{ row.quotedPrice }}
                <i
                  v-if="row.settlementId == null"
                  slot="reference"
                  class="el-icon-edit fl"
                  @click="editQuotedPrice(row, rowIndex)"
                />
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
            <div class="font10">
              <el-popover
                placement="right"
                width="800"
                trigger="click"
                @show="getDeliveries(row)"
              >
                <vxe-table
                  :data="deliveries"
                  id="deliverInfosTable"
                  row-id="id"
                  ref="deliverInfosTable"
                  class="recordsTable"
                  size="mini"
                  resizable
                  round
                  auto-resize
                  highlight-hover-row
                  :scroll-y="{ enabled: false }"
                >
                  <vxe-table-column
                    field="deliverType"
                    :title="$t('delivery.deliveryMethode')"
                  >
                    <template v-slot="{ row }">
                      <span v-if="row.deliverType != null">{{
                        $t("deliverTypes." + row.deliverType)
                      }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="express"
                    :title="$t('delivery.express')"
                  />
                  <vxe-table-column
                    field="deliverMethodName"
                    :title="$t('delivery.channel')"
                  />
                  <vxe-table-column
                    field="tracking"
                    :title="$t('delivery.tracking')"
                  />
                  <vxe-table-column
                    field="attachment"
                    :title="$t('product.attachment')"
                  >
                    <template v-slot="{ row }">
                      <thumbnail-text :srcs="row.attachment" :text="'附件'" />
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="deliverBy"
                    :title="$t('delivery.deliverBy')"
                  />
                  <vxe-table-column
                    field="deliverAt"
                    :title="$t('delivery.deliverAt')"
                  />
                  <vxe-table-column
                    field="remark"
                    :title="$t('bargain.deliveryRemark')"
                  >
                    <template v-slot="{ row }">
                      <raw-html-limit-number
                        :content="row.remark"
                        :number="12"
                      />
                    </template>
                  </vxe-table-column>
                </vxe-table>
                <span slot="reference" class="popover-reference">
                  {{ $t("order.delivered") }}:{{ row.deliveredQuantity
                  }}{{ row.unit || "" }}
                </span>
              </el-popover>
            </div>
            <div v-if="row.customerReceiveAt != null" class="font10">
              {{ $t("order.customerReceiveAt") }}:{{ row.customerReceiveAt }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="dealType"
          :title="$t('order.dealType')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.dealType !== null">{{
              $t("orderDealTypes." + row.dealType)
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('text.createAt')" min-width="110">
          <template v-slot="{ row }">
            <span v-if="row.createAt.slice(11, 19) == '00:00:00'">
              {{ row.createAt.slice(0, 10) }}
            </span>
            <span v-else>
              {{ row.createAt }}
            </span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span> 条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- ===== -->
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="showBargainDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-bargain :id="currentRowBargainId" />
    </drawer>

    <drawer
      :title="$t('text.view', [$t('menu.orders')])"
      :visible.sync="showOrderDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-order :id="currentRowOrderId" @updated="orderUpdated" />
    </drawer>

    <!-- 发货 -->
    <el-dialog
      :title="$t('action.applyTracking')"
      :close-on-click-modal="false"
      :visible.sync="batchGetTrackingDF"
      width="80%"
    >
      <el-form
        ref="batchGetTrackingObjForm"
        :model="batchGetTrackingObj"
        label-width="80px"
      >
        <table
          class="table"
          cellspacing="0"
          cellpadding="0"
          border="0"
          style="width: 100%"
        >
          <thead class="thead">
            <tr>
              <th width="80">{{ $t("product.images") }}</th>
              <th min-width="120">{{ $t("order.serialNo") }}</th>
              <th min-width="120">{{ $t("product.productNo") }}</th>
              <th min-width="80">{{ $t("text.quantity") }}</th>
              <th min-width="80">{{ $t("text.remark") }}</th>
            </tr>
          </thead>
          <tbody
            v-for="(row, rowIndex) in batchGetTrackingBargains"
            :key="rowIndex"
            class="tbody"
          >
            <tr class="tbody-total">
              <td colspan="9">
                <span class="mgr5 float-left pdt7">
                  {{ row.serialNo }}
                </span>
                <span>
                  <el-input
                    size="small"
                    v-model="row.goodsName"
                    :placeholder="$t('delivery.goodsName')"
                    class="mgr5 float-left"
                    style="width: 100px"
                    @blur="blurDeliverAttribute(rowIndex, 'goodsName')"
                  />
                  <el-input
                    size="small"
                    v-model="row.goodsNameEn"
                    :placeholder="$t('delivery.goodsNameEn')"
                    class="mgr5 float-left"
                    style="width: 100px"
                    @blur="blurDeliverAttribute(rowIndex, 'goodsNameEn')"
                  />
                  <el-input
                    size="small"
                    v-model="row.hsCode"
                    :placeholder="$t('delivery.hsCode')"
                    class="mgr5 float-left"
                    style="width: 100px"
                  />
                  <el-input
                    size="small"
                    v-model.trim="row.weight"
                    :placeholder="$t('delivery.weight')"
                    class="mgr5 float-left"
                    style="width: 80px"
                  />
                  <el-input
                    size="small"
                    v-model.trim="row.insured"
                    :placeholder="$t('delivery.insured')"
                    class="mgr5 float-left"
                    style="width: 80px"
                    @blur="blurDeliverAttribute(rowIndex, 'insured')"
                  />
                </span>
                <span class="float-right font10 pdt7 mgr5">
                  <el-popover placement="right" width="300" trigger="click">
                    <div>
                      <div class="lineH24">
                        {{ $t("menu.customers") }}：{{ row.customerName }}
                      </div>
                      <div class="lineH24">
                        {{ $t("bargain.customerType") }}：
                        {{ $t("customerTypes." + row.customerType) }}
                      </div>
                      <div class="lineH24">
                        {{ $t("bargain.customerPhone") }}：
                        {{ row.customerPhone }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.country") }}：
                        <span v-if="row.customerCountry != null">{{
                          $t("countries." + row.customerCountry)
                        }}</span>
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.province") }}：{{ row.customerProvince }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.city") }}：{{ row.customerCity }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.address") }}：{{ row.customerAddress }}
                      </div>
                      <div class="lineH24">
                        {{ $t("customer.zipcode") }}：{{ row.customerZipcode }}
                      </div>
                    </div>
                    <span slot="reference" class="popover-reference">
                      {{ $t("menu.customers") }}：{{ row.customerName }}
                    </span>
                  </el-popover>
                </span>
              </td>
            </tr>
            <tr v-for="item in row.orders" :key="item.id">
              <td>
                <thumbnail :images="item.images"></thumbnail>
              </td>
              <td style="word-wrap: break-word">
                <small v-if="item.hurry" class="red">
                  ({{ $t("order.hurrySimple") }})
                </small>
                {{ row.serialNo }}
                <div>
                  <state-label :state="item.workflowState">
                    {{ $t("orderStates." + item.workflowState) }}
                  </state-label>
                  <small v-if="item.replaceDeliver" class="red">
                    {{ $t("purchase.replaceDeliver") }}
                  </small>
                </div>
              </td>
              <td>
                {{ item.productNo }}
                <div class="font10">{{ item.categoryName }}</div>
                <div class="font10">{{ item.color }} {{ item.size }}</div>
              </td>
              <td>{{ item.quantity }}{{ item.unit }}</td>
              <td>
                <raw-html-limit-number
                  :content="item.remark"
                  :number="20"
                  type="richText"
                />
                <div>
                  <attribute :content="item.specJson" :number="6" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="batchGetTrackingSubmitDoing"
          size="small"
          @click="batchGetTrackingSubmit()"
          >{{ $t("action.deliver") }}</el-button
        >
        <el-button size="small" @click="batchGetTrackingDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import ls from "store2";
import Cookies from "js-cookie";

import { table, page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";

import { flagsWithClear, flagsWithNone, customerTypes } from "@/utils/enums.js";
import DateRange from "@/components/DateRange";
import Currency from "@/components/Currency";
import RawHtml from "@/components/RawHtml";
import ThumbnailText from "@/components/ThumbnailText";
import Dropzone from "@/components/Dropzone";
import CustomerSearch from "@/components/CustomerSearch";

//
import Bargain from "@/api/bargain.js";
import Order from "@/api/order.js";
import User from "@/api/user.js";
import Category from "@/api/category.js";
import Enumeration from "@/api/enumeration.js";
import Shop from "@/api/shop.js";
import Delivery from "@/api/delivery";
import PayMethod from "@/api/payMethod";
import Customer from "@/api/customer";
import Brand from "@/api/brand";
import Courier from "@/api/courier";
import Express from "@/api/express";
import CouriersRequestResponse from "@/api/couriersRequestResponse";

//
import ShowBargain from "@/views/oms/bargains/showBargain.vue";
import ShowOrder from "@/views/oms/bargains/showOrder.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    Currency,
    RawHtml,
    ThumbnailText,
    Dropzone,
    CustomerSearch,

    ShowBargain,
    ShowOrder,
  },

  data() {
    return {
      Util: Util,
      flagsWithClear: flagsWithClear,
      flagsWithNone: flagsWithNone,
      customerTypes: customerTypes,
      sorter: {
        sortBy: "bargains_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        handOverAt: "orders.hand_over_at",
      },
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: Order.nearRange,
          },
          {
            label: this.$t("order.passRange"),
            items: Order.passRange,
          },
          {
            label: this.$t("text.flag"),
            items: flagsWithNone.map((flag) => {
              return { flag: flag, key: flag, condition: { flag: flag } };
            }),
          },
        ],
        [
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
              {
                label: this.$t("settleInfo.no"),
                key: "unSettleNo",
                condition: { unsettle: "no" },
              },
              {
                label: this.$t("bargain.settled"),
                key: "zero",
                condition: { payInfo: "zero" },
              },
              {
                label: this.$t("order.debt"),
                key: "debt",
                condition: { payInfo: "debt" },
              },
              {
                label: this.$t("order.balance"),
                key: "balance",
                condition: { payInfo: "balance" },
              },
              {
                label: this.$t("order.unComplated"),
                key: "unComplated",
                condition: {
                  workflowStates: [
                    "placed",
                    "pending",
                    "preparing",
                    "prepared",
                    "processing",
                    "processed",
                    "purchasing",
                    "purchased",
                    "shipped",
                    "partially",
                  ],
                },
              },
            ],
          },
          {
            label: this.$t("order.orderResource"),
            items: [
              {
                label: "手动录入的",
                key: "entryMethodManual",
                condition: { entryMethod: "manual" },
              },
              {
                label: "自动导入的",
                key: "entryMethodAuto",
                condition: { entryMethod: "auto" },
              },
              // {
              //   label: this.$t("orderResources.followYes"),
              //   key: "followYes",
              //   condition: { follow: "yes" },
              // },

              {
                label: this.$t("orderResources.followNo"),
                key: "followNo",
                condition: { follow: "no" },
              },
            ],
          },
        ],
        [
          {
            label: "申请运单号情况",
            items: [
              {
                label: "运单号异常",
                key: "isFailYes",
                condition: { isFail: "yes" },
              },
              {
                label: "运单号正常",
                key: "isFailNo",
                condition: { isFail: "no" },
              },
            ],
          },
          {
            label: "运单号情况",
            items: [
              {
                label: "有运单号",
                key: "hasTrackingYes",
                condition: { hasTracking: "yes" },
              },
              {
                label: "无运单号",
                key: "hasTrackingNo",
                condition: { hasTracking: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: "hasTrackingNo",
      searchForm: {
        keyword: null,
        customerId: null,
        customerName: null,
        productNo: null,
        createAtStartAt: null,
        createAtEndAt: null,
        handOverAtStartAt: null,
        handOverAtEndAt: null,
        ownerId: null,
        shopId: null,
        categoryName: null,
        customerType: null,
        productBrand: null,
        color: null,
        size: null,
        specJson: null,
        remark: null,
        deliveryRemark: null,
        latestShipDateStartAt: null,
        latestShipDateEndAt: null,
        latestDeliveryDateStartAt: null,
        latestDeliveryDateEndAt: null,
      },
      users: [],
      categories: [],
      groups: [],
      groupsNarrow: [],
      shops: [],
      shopsInv: [],
      brands: [],
      deliveries: [],
      courierTenants: [],
      currentRowIdx: null,
      currentRowBargainId: null,
      currentRowBargainUuid: null,
      currentRowOrderId: null,

      showBargainDF: false,
      showOrderDF: false,
      //--
      batchGetTrackingDF: false,
      batchGetTrackingObj: {
        courierId: null,
        courierName: null,
        deliverMethodId: null,
        deliverMethodName: null,
        deliverMethodCode: null,
      },
      batchGetTrackingSubmitDoing: false,
      batchGetTrackingBargains: [],
      requestResponses: [],
      //
      cancelTrackingDoing: false,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    self.narrowsWorkflowStates();
    self.narrowsFinanceVerifyInfo();
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Category.findByTenantId(),
        Enumeration.findByType("group"),
        Shop.findByTenantId(),
        Brand.findByTenantId(),
        Courier.findCourierTenantByTenantId(),
      ])
      .then(
        axios.spread(function (
          users,
          categories,
          groups,
          shops,
          brands,
          courierTenants
        ) {
          if (users.status === 200) {
            self.users = users.data.filter((u) => u.authorize === true);
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (groups.data.code === 200) {
            self.groups = JSON.parse(groups.data.entity.itemsJson);
            self.groupsNarrow = self.groups.concat(["none"]);
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
            self.shopsInv = shops.data.filter((s) => s.isInventory === true);
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.brands = brands.data;
          } else {
            self.sysError();
          }
          if (courierTenants.status === 200) {
            self.courierTenants = courierTenants.data;
          } else {
            self.sysError();
          }
          self.narrowsBrandsGroups();
        })
      );
  },
  methods: {
    blurDeliverAttribute(index, attribute) {
      const self = this;
      if (
        index == 0 &&
        self.batchGetTrackingBargains[index][attribute] != null &&
        self.batchGetTrackingBargains[index][attribute] != "" &&
        self.batchGetTrackingBargains.length != 0
      ) {
        for (const b of self.batchGetTrackingBargains) {
          if (b[attribute] == null || b[attribute] == "") {
            b[attribute] = self.batchGetTrackingBargains[0][attribute];
          }
        }
      }
    },
    canCancelTracking(row) {
      if (row && row.orders && row.orders.length == 0) {
        return false;
      }
      let stas = row.orders.map((c) => c.workflowState);
      let stasSet = [...new Set(stas)];

      for (const sta of stasSet) {
        if (
          [
            "forout",
            "partially",
            "finished",
            "shipped",
            "returned",
            "canceled",
          ].includes(sta)
        ) {
          return false;
        }
      }
      return true;
    },

    // narrows ====
    narrowsBrandsGroups() {
      this.narrows.push([
        {
          label: this.$t("product.brand"),
          items: this.brands.map((brand) => {
            return {
              label: brand.name,
              key: brand.name,
              condition: { productBrand: brand.name },
            };
          }),
        },
        {
          label: this.$t("action.group"),
          items: this.groupsNarrow.map((group) => {
            return {
              label: group == "none" ? "无" : group,
              key: JSON.stringify(group),
              condition: {
                groupJson: group == "none" ? group : JSON.stringify(group),
              },
            };
          }),
        },
      ]);
    },
    narrowsFinanceVerifyInfo() {
      if (!this.Permit.isFreeEdition()) {
        this.narrows[1].push({
          label: this.$t("bargain.financeVerifyInfo"),
          items: [
            {
              label: this.$t("verifyInfos.agree"),
              key: "financeVerifyAgree",
              condition: { financeVerify: "agree" },
            },
            {
              label: this.$t("verifyInfos.reject"),
              key: "financeVerifyReject",
              condition: { financeVerify: "reject" },
            },
            {
              label: this.$t("verifyInfos.no"),
              key: "financeVerifyNo",
              condition: { financeVerify: "no" },
            },
          ],
        });
      }
    },
    narrowsWorkflowStates() {
      const self = this;
      if (self.Permit.canActions("orderDealView")) {
        var states = Order.states_pre;
        if (self.Permit.canActionsConfigDealType("available")) {
          states = states.concat(Order.states_available);
        }
        if (self.Permit.canActionsConfigDealType("purchase")) {
          states = states.concat(Order.states_purchase);
        }
        if (self.Permit.canActionsConfigDealType("manufacture")) {
          states = states.concat(Order.states_manufacture);
        }
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: states.concat(Order.states_after).map((s) => {
              return {
                key: s,
                label: self.$t("orderStates." + s),
                condition: { workflowStates: [s] },
              };
            }),
          },
        ]);
      } else {
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: Order.states_no_permint.map((s) => {
              return {
                key: s.key,
                label: self.$t("orderStates." + s.key),
                condition: { workflowStates: s.workflowStates },
              };
            }),
          },
        ]);
      }
    },

    // 上传跟踪号
    batchUploadTracking() {
      const self = this;

      const selectRecordsFilter = this.selectedBargains().filter(
        (c) => c.tracking != null
      );
      // &&
      //     c.deliverType !== "carry" &&
      //     c.deliverType !== "take"
      if (selectRecordsFilter.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneTrackingData2"));
        return;
      }
      if (confirm("半小时后到平台检查上传结果")) {
        Bargain.batchUploadTracking(selectRecordsFilter.map((c) => c.id)).then(
          function (res) {
            if (res.status === 200) {
              self.sysResults(
                res.data,
                self.$t("prompt.batchUploadTrackingSuccess")
              );
              // self.$message({
              //   message: self.$t("prompt.batchUploadTrackingSuccess"),
              //   type: "success",
              // });
            } else {
              self.sysError();
            }
          }
        );
      }
    },
    cancelTracking(row) {
      const self = this;
      self.cancelTrackingDoing = true;
      Bargain.cancelTracking(row.id).then(function (res) {
        self.cancelTrackingDoing = false;
        if (res.status == 200) {
          self.sysResult(res.data);
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    //batchGetTracking
    batchGetTracking(courierTenant, deliverMethod) {
      const self = this;
      if (this.selectedBargains().length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      let bargainFilter = this.selectedBargains().filter(
        (b) => b.tracking == null
      );
      if (bargainFilter.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneDataNoTracking"));
        return;
      }
      self.batchGetTrackingObj.courierId = courierTenant.courierId;
      self.batchGetTrackingObj.courierName = courierTenant.courier.name;
      self.batchGetTrackingObj.deliverMethodId = deliverMethod.id;
      self.batchGetTrackingObj.deliverMethodName = deliverMethod.name;
      self.batchGetTrackingObj.deliverMethodCode = deliverMethod.code;
      self.batchGetTrackingBargains = self
        .selectedBargains()
        .filter((b) => b.orders.length != 0 && b.tracking == null);
      for (const bargain of self.batchGetTrackingBargains) {
        if (bargain.isFail == true && bargain.bargainCourierInfo != null) {
          Vue.set(bargain, "insured", bargain.bargainCourierInfo.insured);
          Vue.set(bargain, "hsCode", bargain.bargainCourierInfo.hsCode);
          Vue.set(bargain, "goodsName", bargain.bargainCourierInfo.goodsName);
          Vue.set(
            bargain,
            "goodsNameEn",
            bargain.bargainCourierInfo.goodsNameEn
          );
          Vue.set(bargain, "weight", bargain.bargainCourierInfo.selfWeight);
        } else {
          let obj = null;
          let categoryId = bargain.orders[0].categoryId;
          obj = self.categories.find((c) => c.id == categoryId);
          Vue.set(bargain, "insured", obj != null ? obj.insured : null);
          Vue.set(bargain, "hsCode", obj != null ? obj.hsCode : null);
          Vue.set(bargain, "goodsName", obj != null ? obj.goodsName : null);
          Vue.set(bargain, "goodsNameEn", obj != null ? obj.goodsNameEn : null);
          Vue.set(bargain, "weight", obj != null ? obj.weight : null);
        }
      }

      self.batchGetTrackingDF = true;
    },

    batchGetTrackingSubmit() {
      const self = this;
      if (self.batchGetTrackingBargains.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData2"));
        return;
      }
      const data = self.batchGetTrackingBargains.map((b) => {
        return {
          id: b.id,
          courierId: self.batchGetTrackingObj.courierId,
          courierName: self.batchGetTrackingObj.courierName,
          deliverMethodId: self.batchGetTrackingObj.deliverMethodId,
          deliverMethodName: self.batchGetTrackingObj.deliverMethodName,
          deliverMethodCode: self.batchGetTrackingObj.deliverMethodCode,
          insured: b.insured,
          hsCode: b.hsCode,
          goodsName: b.goodsName,
          goodsNameEn: b.goodsNameEn,
          weight: b.weight,
        };
      });
      self.batchGetTrackingSubmitDoing = true;
      Bargain.batchGetTracking(data).then(function (res) {
        self.batchGetTrackingSubmitDoing = false;
        self.batchGetTrackingDF = false;
        if (res.status == 200) {
          self.sysResults(res.data);
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    cancelBardain(row) {
      if (row && row.orders && row.orders.length == 0) {
        return false;
      }
      let stas = row.orders.map((c) => c.workflowState);
      let stasSet = [...new Set(stas)];
      if (stasSet.length == 1 && stasSet[0] == "canceled") {
        return true;
      }
      return false;
    },

    getRequestResponses(row) {
      const self = this;
      CouriersRequestResponse.findByDeliverySerialNo({
        deliverySerialNo: row.serialNo,
      }).then(function (res) {
        if (res.status == 200) {
          self.requestResponses = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // 获取发货信息
    getDeliveries(row) {
      const self = this;
      Delivery.findByOrderUuid(row.uuid).then(function (res) {
        if (res.status == 200) {
          self.deliveries = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //=========
    showOrder(row, currentRowIdx) {
      this.currentRowIdx = currentRowIdx;
      this.currentRowOrderId = row.id;
      this.showOrderDF = true;
    },
    showBargain(row) {
      this.currentRowBargainId = row.id;
      this.showBargainDF = true;
    },
    orderUpdated(order) {
      for (const key in this.records[this.currentRowIdx]) {
        this.records[this.currentRowIdx][key] = order[key];
      }
      this.editOrderDF = false;
    },
    //=====
    dataProvider(params) {
      return Bargain.applyTrackingWebSearchNoOrders(params);
    },
    recordsDecorate(records) {
      const self = this;
      for (const record of records) {
        Vue.set(record, "orders", []);
        Vue.set(record, "isLoadDF", true);
      }
      self.records = self.buildTableData(records, "first");
      self.mergeCells = self.buildMergeCells(records, "first");

      if (records.map((r) => r.id).length != 0) {
        Bargain.findWithOrdersByIdsForList(records.map((r) => r.id)).then(
          function (res) {
            if (res.status == 200) {
              for (const record of res.data) {
                Vue.set(record, "loadingDF", false);
              }
              let newBargain = JSON.parse(JSON.stringify(res.data));
              for (const record of records) {
                let index = newBargain.findIndex((d) => d.id == record.id);
                if (index != -1) {
                  record.orders = newBargain[index].orders;
                  newBargain.splice(index, 1);
                } else {
                  record.orders = [];
                }
              }
              self.records = self.buildTableData(records, "second");
              self.mergeCells = self.buildMergeCells(records, "second");
            } else {
              self.sysError();
            }
          }
        );
      }
    },
    buildTableData(records, type) {
      let rs = [];
      records.forEach((record) => {
        let bOrder = {
          isBargain: true,
          id: record.id,
          uuid: record.uuid,
          serialNo: record.serialNo,
          shopId: record.shopId,
          shopName: record.shopName,
          settleType: record.settleType,
          amount: record.amount,
          currency: record.currency,
          customerId: record.customerId,
          customerName: record.customerName,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerPhone: record.customerPhone,
          customerZipcode: record.customerZipcode,
          customerType: record.customerType,
          customerSource: record.customerSource,
          customerEmail: record.customerEmail,
          deliveryRemark: record.deliveryRemark,
          groupJson: record.groupJson,
          remark: record.remark,
          ownerId: record.ownerId,
          ownerName: record.ownerName,
          createAt: record.createAt,
          plateform: record.plateform,
          plateformBargainId: record.plateformBargainId,
          cnyAmount: record.cnyAmount,
          replaceCustomerId: record.replaceCustomerId,
          lastDealtAt: record.lastDealtAt,
          customer: record.customer,
          productAmount: record.productAmount,
          // currentMonthAmount: record.currentMonthAmount,
          plateformStoreId: record.plateformStoreId,
          financeDeliveryAt: record.financeDeliveryAt,
          deliveryAudit: record.deliveryAudit,
          financeAudit: record.financeAudit,
          payAmount: record.payAmount,
          productQty: record.productQty,
          differAmount: record.differAmount,
          ignoreAmount: record.ignoreAmount,
          orders: record.orders,
          isFail: record.isFail,
          tracking: record.tracking,
          bargainCourierInfo: record.bargainCourierInfo,
          latestDeliveryDate: record.latestDeliveryDate,
          latestShipDate: record.latestShipDate,
        };
        rs.push(bOrder); //将bargain的数据转换到格式，放到数据列表
        // record.orders.forEach((order) => {
        //   rs.push(order);
        // });
        if (record.orders && record.orders.length != 0) {
          for (const order of record.orders) {
            Vue.set(order, "_bargain", bOrder);
            rs.push(order);
          }
        } else {
          if (type == "first") {
            rs.push({ isLoadDF: true, orders: [] });
          }
        }
      });
      return rs;
    },
    buildMergeCells(bargains, type) {
      let mcs = [];
      if (type == "first") {
        for (let i = 0, rowIdx = 0; i < this.pager.pageSize * 2; i++) {
          if (this.Permit.canActions("globalSalePrice")) {
            mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 12 });
          } else {
            mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 11 });
          }
          rowIdx = rowIdx + 1;
        }
        return mcs;
      } else {
        for (let i = 0, rowIdx = 0; i < bargains.length; i++) {
          if (this.Permit.canActions("globalSalePrice")) {
            mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 11 });
          } else {
            mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 10 });
          }
          rowIdx = rowIdx + bargains[i].orders.length + 1;
        }
        return mcs;
      }
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isBargain
        ? "light-blue-bg"
        : row.isLoadDF
        ? ""
        : this.rowBgColor({ row: row, rowIndex: rowIndex });
    },
    isNear(row) {
      //定义近交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (!noColorWorkflowStates.includes(row.workflowState)) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return true;
        }
      }
      return false;
    },
    isPass(row) {
      //定义过交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (!noColorWorkflowStates.includes(row.workflowState)) {
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return true;
        }
      }
      return false;
    },
    setSelectedQty() {
      this.selectRecordQty =
        this.$refs.recordsTable &&
        this.$refs.recordsTable.getCheckboxRecords().filter((r) => !r.isBargain)
          .length;
    },
    selectedBargains() {
      // console.log("=====selectedBargains:");
      return this.$refs.recordsTable
        .getCheckboxRecords()
        .filter((r) => r.isBargain);
    },
    selectedOrders() {
      // console.log("=====selectedOrders:");
      return this.$refs.recordsTable
        .getCheckboxRecords()
        .filter((r) => !r.isBargain);
    },
    selectRecord({ rowIndex, selection, checked, row, data }) {
      // console.log("====selectRecord");
      if (row.isBargain) {
        let orders = data.filter((r) => r.bargainId == row.id);
        this.$refs.recordsTable.setCheckboxRow(orders, checked);
      }
      this.setSelectedQty();
    },
    selectAllRecords() {
      // console.log("=====selectAllRecords");
      this.setSelectedQty();
    },

    checkColumnMethod({ row }) {
      if (row.isBargain) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.group {
  float: left;
  margin-left: 10px;
  border: 1px solid rgba(64, 158, 255, 0.2);
  color: #409eff;
  background: rgba(64, 158, 255, 0.1);
  padding: 0px 4px;
  border-radius: 3px;
  font-size: 12px;
}
.agentBg {
  margin-bottom: 5px;
  font-size: 14px;
}
.agentBg:hover {
  cursor: pointer;
  color: #409eff;
  background: #edf4fd;
}
.table {
  width: 100%;
  font-size: 14px;
}

.thead tr {
  height: 40px;
  line-height: 40px;
  color: #909399;
  font-weight: 500;
}

.tbody tr td {
  padding: 4px;
}
.tbody {
  color: #606266;
}
.tbody-total {
  background: #eff8ff;
}
.tbody td {
  border-bottom: 1px solid #ebeef5;
  text-align: left;
  padding-left: 6px;
}
.thead th {
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  text-align: left;
  padding-left: 6px;
}
</style>